// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
import HoverMRRDescription from './HoverMRRDescription'
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TimeClocksProductRow() {
   const state = useQuoteContext()
   const { getFormattedString } = state
   const rowPermissions = state.featurePermissions['TimeClocks']
   const permissionsShowMRROnDifferenceQuotes =
      state.featurePermissions['ShowMRROnDifferenceQuotes']
   const ShowMRROnDifferenceQuotes =
      permissionsShowMRROnDifferenceQuotes.includes(state.user_role)

   if (
      (rowPermissions.includes(state.user_role) ||
         state.productHasTimeClocks) &&
      state.product_list &&
      state.product_list.hasOwnProperty('clockMonthlySupport') &&
      state.product_list['clockMonthlySupport']
   ) {
      return (
         <div className='row'>
            <div className='col-bhr1'>
               <div
                  dangerouslySetInnerHTML={{
                     __html: getFormattedString(
                        'product.TimeClocksProductRow.ProductName',
                        {
                           basePrice: formatFloatAsCurrencySymbol(
                              state.product_list['clockMonthlySupport'][
                                 'BasePrice'
                              ],
                              state.currencyObject,
                           ),
                        },
                     ),
                  }}
               />
            </div>
            <div className='col-bhr2'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.productHasTimeClocks}
                  onChange={() =>
                     state.setProductHasTimeClocks((prev) => !prev)
                  }
               />
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {state.productTimeClockDetails.length > 0 &&
                  formatFloatAsCurrencySymbol(
                     state.TimeClockMonthlyCost.totalPrice,
                     state.currencyObject,
                  )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col col-bhr-blue'>
                     {state.TimeClockMonthlyCost.previousTotalPrice > 0 &&
                        formatFloatAsCurrencySymbol(
                           state.TimeClockMonthlyCost.previousTotalPrice,
                           state.currencyObject,
                        )}
                  </div>
                  {ShowMRROnDifferenceQuotes ? (
                     <HoverMRRDescription
                        listMRRTotal={state.TimeClockMonthlyCost.listMRRTotal}
                        previousMRRTotal={
                           state.TimeClockMonthlyCost.previousMRRTotal
                        }
                        MRRTotal={state.TimeClockMonthlyCost.MRRTotal}
                        MRRTotalUSD={state.TimeClockMonthlyCost.MRRTotalUSD}
                        currencyObjectCurrent={state.currencyObject}
                        currencyObjectUSD={state.currencyObjectUSD}
                     >
                        <span className='hoverable'>
                           {formatFloatAsCurrencySymbol(
                              state.TimeClockMonthlyCost.totalPriceDifference ||
                                 0,
                              state.currencyObject,
                           )}
                        </span>
                     </HoverMRRDescription>
                  ) : (
                     <span className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.TimeClockMonthlyCost.totalPriceDifference || 0,
                           state.currencyObject,
                        )}
                     </span>
                  )}
                  {process.env.REACT_APP_ENVIRONMENT == 'staging' && (
                     <div className='col'>
                        {formatFloatAsCurrencySymbol(
                           state.TimeClockMonthlyCost?.MRRTotal ?? 0,
                           state.currencyObject,
                        )}
                     </div>
                  )}
               </>
            ) : (
               <></>
            )}
         </div>
      )
   }
}
